import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../api/quarkusApi';

export function useProfessionals() {
  const navigate = useNavigate();

  const [professionals, setProfessionals] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchProfessionals = useCallback(() => {
    setLoading(true);
    quarkusApi
      .get('/dentists/combobox', { headers: { Authorization: sessionStorage.getItem('token') } })
      .then((returnFromApi) => setProfessionals(returnFromApi.data))
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data);
        console.error('ops! ocorreu um erro' + returnFromApi);
        if (returnFromApi.status === 401) {
          navigate('/expired-session');
        }
      })
      .finally(() => setLoading(false));
  }, [navigate]);

  useEffect(() => {
    fetchProfessionals();
  }, [fetchProfessionals]);

  return { professionals, isLoading, error, refetch: fetchProfessionals };
}
